import { useParams } from "react-router-dom";
import { timeAgo } from "../../shared-components";
import { useJobDetails } from "../../network/APIs/jobs";
import { Helmet } from "react-helmet";
import { getFirstLetterCapital } from "../../shared-components/constants/constants";
import {
  ArrowLeft,
  Building2,
  MapPin,
  Clock,
  Send,
  Share2,
  Briefcase,
  Zap,
  DollarSign,
  IndianRupee,
  Calendar,
  GraduationCap,
  X,
  Mail as MailIcon,
} from "lucide-react";
import { getDefaultImage } from "../../shared-components/constants/constants";
import LoginPage from "../auth/LoginPage";
import SignupPage from "../auth/SignupPage";
import { useEffect, useState } from "react";

import { postAnalysis } from "../../network/APIs/analysis";
import { gaEvents } from "../../shared-components/google-analytics-events/ga-events";
import { Alert, Snackbar, LinearProgress } from "@mui/material";
import { SharePopover } from "../../shared-components";
import {
  getSharingTextForJobs,
  getFullURLPath,
} from "../../shared-components/constants/constants";

const JobDescription = () => {
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [isSignupOpen, setIsSignupOpen] = useState(false);
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [emailData, setEmailData] = useState({ email: "", subject: "", body: "" });
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  let { id } = useParams();

  const { data: jobData, isLoading, isFetching } = useJobDetails(id);
  console.log("jobData", jobData);

  const userData = localStorage.getItem("Freshment_user_data");
  const userdetail = userData ? JSON.parse(userData) : null;

  const isApplicationClosed = jobData?.details?.application_end_date
    ? new Date(jobData.details.application_end_date).setHours(23, 59, 59, 999) <
    new Date()
    : false;

  const apply_online_analytics = () => {
    gaEvents.apply_online_job(
      +jobData.details.id,
      +jobData.details.job_category_id,
    );
  };

  const send_resume_job = () => {
    gaEvents.apply_online_job(
      +jobData.details.id,
      +jobData.details.job_category_id,
    );
  };

  const call_hr_job = () => {
    gaEvents.apply_online_job(
      +jobData.details.id,
      +jobData.details.job_category_id,
    );
  };

  const view_advt_job = () => {
    gaEvents.apply_online_job(
      +jobData.details.id,
      +jobData.details.job_category_id,
    );
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  const Analysis = ({ job_id, user_id, type, operation, link }) => {
    // console.log("dfsdf ", { job_id, user_id, type, operation, link });
    const isAuth = localStorage.getItem("Freshment_user_data");

    if (isApplicationClosed && type !== "share") {
      setSnackbarMsg("We are no longer accepting applications for this job.");
      setSnackbarSeverity("info");
      setOpenSnackbar(true);
      return;
    }

    // Interaction types that should not be blocked by login
    const isPublicAction = ["SendResume", "CallHR", "apply_now"].includes(type);

    if (!isAuth) {
      setIsLoginOpen(true);
      return;
    }

    // Perform the requested action FIRST to ensure responsiveness
    try {
      switch (type) {
        case "SendResume":
          send_resume_job();
          const emailAddr = (link || "").toString().replace(/^mailto:/i, "").trim();
          const subjectStr = `Application for ${jobData?.details?.name || "Job"}`;
          const bodyStr = `Hello,\n\nI am interested in applying for the ${jobData?.details?.name || "Job"
            } position at ${jobData?.details?.company_name || "your company"
            } as posted on Freshment.\n\nPlease find my resume attached for your review.\n\nBest regards,\n${userdetail?.data?.name || ""
            }`;

          setEmailData({
            email: emailAddr,
            subject: subjectStr,
            body: bodyStr,
          });
          setIsEmailModalOpen(true);

          // Still copy to clipboard as a backup
          try {
            if (navigator.clipboard) {
              navigator.clipboard.writeText(emailAddr);
            }
          } catch (e) { }
          break;

        case "apply_now":
          apply_online_analytics();
          const webLink = link.startsWith("http") ? link : `https://${link}`;
          window.open(webLink, "_blank", "noopener,noreferrer");
          break;

        case "CallHR":
          call_hr_job();
          const phoneNum = link.replace(/[^\d+]/g, "");
          window.location.href = `tel:${phoneNum}`;
          break;

        case "like":
          setSnackbarMsg(
            "Your interest in the job has been successfully recorded. Thank you!",
          );
          setSnackbarSeverity("success");
          setOpenSnackbar(true);
          break;

        default:
        console.warn(`Unhandled analysis type: ${type}`);
      }
    } catch (actionError) {
      console.error("Action execution failed:", actionError);
    }

    // Perform tracking analysis in the background
    try {
      const Data = { job_id, user_id, type, operation };
      postAnalysis(Data);
    } catch (error) {
      console.error("Error performing tracking analysis:", error);
    }
  };

  useEffect(() => {
    const container = document.querySelector(".description-container");
    if (container) {
      const links = container.querySelectorAll("a");
      links.forEach((link) => {
        link.setAttribute("target", "_blank");
        link.setAttribute("rel", "noopener noreferrer");
      });
    }
  }, [jobData?.details?.description]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-slate-50/50">
        <LinearProgress />
      </div>
    );
  }

  if (!jobData || !jobData.details) {
    return (
      <div className="min-h-screen bg-slate-50/50 pt-6 pb-20 font-sans flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Briefcase className="w-8 h-8 text-slate-400" />
          </div>
          <h2 className="text-xl font-bold text-slate-900 mb-2">
            Job Not Found
          </h2>
          <p className="text-slate-500 mb-6">Unable to load job details.</p>
          <button
            onClick={() => window.history.back()}
            className="bg-blue-600 text-white px-6 py-2.5 rounded-xl font-bold hover:bg-blue-700 transition"
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      {isFetching && (
        <LinearProgress
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            zIndex: 9999,
          }}
        />
      )}
      <Helmet>
        <title>{`Job Id: ${id} - ${jobData?.details?.name}${jobData?.details?.job_location
          ? `, ${jobData?.details?.job_location}`
          : ""
          }`}</title>
        <meta
          name="title"
          content={`Job Id: ${id} - ${jobData?.details?.name}${jobData?.details?.job_location
            ? `, ${jobData?.details?.job_location}`
            : ""
            }`}
        />
        <meta
          name="description"
          content={`Apply for ${jobData?.details?.post_name
            } Job (Job Id: ${id}) ✔ in ${jobData?.details?.company_name}⭐${jobData?.details?.job_location
              ? ` at ${jobData?.details?.job_location},`
              : ""
            } on freshment app. ✔️ ${getFirstLetterCapital(
              jobData?.details?.job_type,
            )} ✔️ ${jobData?.details?.category_name} Jobs | freshmentapp.com`}
        />
        <meta
          name="image"
          content="https://freshmentapp.com/static/media/freshmentLogo.a5200e9f.svg"
        />

        <link
          rel="canonical"
          href={`https://freshmentapp.com/job-description/${id}`}
        />
        <link
          rel="alternate"
          href={`https://freshmentapp.com/job-description/${id}`}
          hrefLang="en-in"
        />

        <meta name="author" content="freshment" />
        <meta property="business:contact_data:locality" content="Rajkot" />
        <meta property="business:contact_data:postal_code" content="360002" />
        <meta property="business:contact_data:country_name" content="India" />
        <meta
          property="business:contact_data:email"
          content="contact@freshmentapp.com"
        />
        <meta
          property="business:contact_data:website"
          content="https://freshmentapp.com"
        />
        <meta
          itemProp="name"
          content="Freshment - Find a candidate in 72 hours, Find a job in 7 days"
        />
        <meta property="profile:username" content="freshment" />
        <meta
          itemProp="description"
          content={`Apply for ${jobData?.details?.post_name
            } Job (Job Id: ${id}) ✔ in ${jobData?.details?.company_name}⭐${jobData?.details?.job_location
              ? ` at ${jobData?.details?.job_location},`
              : ""
            } on freshment app. ✔️ ${getFirstLetterCapital(
              jobData?.details?.job_type,
            )} ✔️ ${jobData?.details?.category_name} Jobs | freshmentapp.com`}
        />

        <meta
          property="og:title"
          content={`Job Id: ${id} - ${jobData?.details?.name}${jobData?.details?.job_location
            ? `, ${jobData?.details?.job_location}`
            : ""
            }`}
        />

        <meta
          name="og:description"
          content={`Apply for ${jobData?.details?.post_name
            } Job (Job Id: ${id}) ✔ in ${jobData?.details?.company_name}⭐${jobData?.details?.job_location
              ? ` at ${jobData?.details?.job_location},`
              : ""
            } on freshment app. ✔️ ${getFirstLetterCapital(
              jobData?.details?.job_type,
            )} ✔️ ${jobData?.details?.category_name} Jobs | freshmentapp.com`}
        />

        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://freshmentapp.com" />
        <meta
          property="og:determiner"
          content="Post Jobs To Get Candidates | Hire Staff Easily In 72 Hours"
        />
        <meta
          name="twitter:title"
          content={`Job Id: ${id} - ${jobData?.details?.name}${jobData?.details?.job_location
            ? `, ${jobData?.details?.job_location}`
            : ""
            }`}
        />

        <meta
          name="twitter:description"
          content={`Apply for ${jobData?.details?.post_name
            } Job (Job Id: ${id}) ✔ in ${jobData?.details?.company_name}⭐${jobData?.details?.job_location
              ? ` at ${jobData?.details?.job_location},`
              : ""
            } on freshment app. ✔️ ${getFirstLetterCapital(
              jobData?.details?.job_type,
            )} ✔️ ${jobData?.details?.category_name} Jobs | freshmentapp.com`}
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:creator" content="freshment" />
        <meta
          name="twitter:image"
          content="https://freshmentapp.com/static/media/about-office-1.1b443800.png"
        />
        <meta name="robots" content="index,follow" />

        <meta name="google" content="notranslate" />
        <meta http-equiv="Content-Language" content="en_US" />

        <meta
          name="keywords"
          content="fresher jobs alert, fresher jobs, infosys careers, freshment app, internships, b tech fresher jobs, it jobs in pune, it jobs in mumbai, free internship, fresher jobs at deloitte, resume writing, fresher jobs at capgemini, fresher jobs bangalore, fresher jobs bank, fresher jobs btech, fresher jobs btech cse, fresher jobs bca, fresher jobs bcom, civil engineering fresher jobs, work from home jobs for freshers, bank jobs for freshers, tcs hiring, tcs nqt"
        />
      </Helmet>
      <div className="min-h-screen bg-slate-50/50 pt-6 pb-20 font-sans">
        <div className="max-w-5xl mx-auto px-8 xl:px-6 xsm:px-4">
          {/* Breadcrumb / Back */}
          <button
            onClick={() => window.history.back()}
            className="group flex items-center gap-2 text-sm font-bold text-slate-500 hover:text-blue-600 mb-8 transition-colors"
          >
            <div className="p-2 bg-white border border-slate-200 rounded-full group-hover:border-blue-200 transition-colors">
              <ArrowLeft className="w-4 h-4" />
            </div>
            Back to Jobs
          </button>

          <div className="grid grid-cols-12 xl:grid-cols-1 gap-8">
            {/* LEFT COLUMN (8 Cols) */}
            <div className="col-span-8 xl:col-span-1 space-y-8">
              {/* Header Card */}
              <div className="bg-white rounded-[2rem] p-8 border border-slate-100 shadow-[0_4px_20px_rgba(0,0,0,0.02)] relative overflow-hidden">
                {/* Background Pattern */}
                <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-bl from-blue-50 to-transparent rounded-bl-full -mr-16 -mt-16 opacity-50"></div>

                <div className="relative z-10">
                  <div className="flex flex-row sm:flex-col gap-6 items-start">
                    <div className="w-20 h-20 bg-white border border-slate-100 rounded-2xl flex items-center justify-center shadow-sm">
                      <img
                        loading="lazy"
                        src={getDefaultImage(jobData.details.job_category_id)}
                        alt={jobData.details.category_name}
                        width={70}
                        height={70}
                      />
                    </div>

                    <div className="flex-1">
                      <h1 className="text-3xl sm:text-2xl font-black text-slate-900 tracking-tight mb-2">
                        {/* {jobData.details.post_name} */}
                        {jobData.details.name}
                      </h1>
                      <div className="flex flex-wrap items-center gap-4 text-sm font-medium text-slate-600">
                        {jobData.details.job_location && (
                          <>
                            <div className="flex items-center gap-1.5">
                              <MapPin className="w-4 h-4 text-blue-600" />{" "}
                              {jobData.details.job_location}
                            </div>
                            <div className="w-1 h-1 rounded-full bg-slate-300"></div>
                          </>
                        )}

                        <div className="flex items-center gap-1.5">
                          <Clock className="w-4 h-4 text-blue-600" />{" "}
                          {timeAgo(jobData.details.created_at)}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="flex flex-nowrap sm:flex-wrap items-center gap-3 mt-8 overflow-x-auto sm:overflow-x-visible pb-2 sm:pb-0 scrollbar-hide">
                    {isApplicationClosed ? (
                      <div className="flex-1 flex items-center gap-3 bg-red-50 text-red-600 px-6 py-4 rounded-xl font-bold border border-red-100">
                        <Clock className="w-5 h-5" />
                        No longer accepting application
                      </div>
                    ) : (
                      <>
                        {jobData?.details?.apply_online_url && (
                          <button
                            onClick={() => {
                              Analysis({
                                job_id: jobData.details.id,
                                user_id: userdetail?.data?.id ?? null,
                                type: "apply_now",
                                operation: "add",
                                link: jobData.details.apply_online_url,
                              });
                            }}
                            className="flex-none sm:flex-1 bg-blue-600 hover:bg-blue-700 text-white px-8 py-3.5 rounded-xl font-bold shadow-lg shadow-blue-500/30 transition-all active:scale-[0.98] whitespace-nowrap"
                          >
                            Apply Now
                          </button>
                        )}

                        {jobData.details.contact_email && (
                          <button
                            onClick={() => {
                              Analysis({
                                job_id: jobData.details.id,
                                user_id: userdetail?.data?.id ?? null,
                                type: "SendResume",
                                operation: "add",
                                link: jobData.details.contact_email,
                              });
                            }}
                            className="flex-none sm:flex-1 bg-indigo-50 hover:bg-indigo-100 text-indigo-700 border border-indigo-200 px-6 py-3.5 rounded-xl font-bold flex items-center justify-center gap-2 transition-colors whitespace-nowrap"
                          >
                            <Send className="w-4 h-4" /> Send Resume
                          </button>
                        )}

                        {jobData?.details?.contact_number && (
                          <>
                            {/* <a
                          href={`tel:${jobData.details.contact_number}`}
                          className="flex-none sm:flex-1 bg-white border border-slate-200 text-slate-700 hover:bg-slate-50 px-6 py-3.5 rounded-xl font-bold flex items-center justify-center gap-2 transition-colors"
                        >
                          <Phone className="w-4 h-4" /> Call HR
                        </a> */}
                            <button
                              onClick={() => {
                                Analysis({
                                  job_id: jobData.details.id,
                                  user_id: userdetail?.data?.id ?? null,
                                  type: "CallHR",
                                  operation: "add",
                                  link: jobData.details.contact_number,
                                });
                              }}
                              className="flex-none sm:flex-1 bg-white border border-slate-200 text-slate-700 hover:bg-slate-50 px-6 py-3.5 rounded-xl font-bold flex items-center justify-center gap-2 transition-colors whitespace-nowrap"
                            >
                              Call HR
                            </button>
                          </>
                        )}

                        {jobData.details.advertisement_url && (
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={jobData.details.advertisement_url}
                            className="flex-none"
                          >
                            <button
                              onClick={() => view_advt_job()}
                              className="py-3 px-8 sm:px-6 box-border border bg-white border-[#be3fdd] rounded-xl text-[#be3fdd] text-base font-bold whitespace-nowrap"
                            >
                              View Advertisement
                            </button>
                          </a>
                        )}

                        {/* Interested Button */}
                        <button
                          onClick={() => {
                            Analysis({
                              job_id: jobData.details.id,
                              user_id: userdetail?.data?.id ?? null,
                              type: "like",
                              operation: "add",
                              link: "",
                            });
                          }}
                          className="flex-none sm:flex-1 bg-white border border-slate-200 text-slate-700 hover:bg-slate-50 p-3.5 px-6 rounded-xl font-bold flex items-center justify-center gap-2 transition-colors whitespace-nowrap"
                        >
                          Interested
                        </button>
                        <SharePopover
                          url={getFullURLPath()}
                          msg={getSharingTextForJobs(getFullURLPath())}
                        >
                          {/* <button
                    className="m-0 p-0"
                    onClick={() => {
                      const Data = {
                        job_id: details.id,
                        user_id: "45966",
                        type: "share",
                        operation: "add",
                      };
                      postAnalysis(Data);
                    }}
                  > */}
                          <button className="flex-none bg-white border border-slate-200 text-slate-700 hover:bg-slate-50 p-3.5 rounded-xl transition-colors">
                            <Share2 className="w-5 h-5" />
                          </button>
                          {/* </button> */}
                        </SharePopover>
                      </>
                    )}


                  </div>
                </div>
              </div>

              {/* Description Section */}
              <div className="bg-white rounded-[2rem] p-8 border border-slate-100 shadow-[0_4px_20px_rgba(0,0,0,0.02)]">
                <h3 className="text-xl font-bold text-slate-900 mb-6 flex items-center gap-2">
                  <div className="w-8 h-8 rounded-lg bg-blue-50 text-blue-600 flex items-center justify-center">
                    <Briefcase className="w-4 h-4" />
                  </div>
                  Job Description
                </h3>
                <p
                  className="description-container text-slate-600 leading-relaxed mb-8"
                  dangerouslySetInnerHTML={{
                    __html: jobData.details.description,
                  }}
                >
                  {/* {jobData.details.description} */}
                </p>

                {/* <h4 className="text-lg font-bold text-slate-900 mb-4">
                  Roles & Responsibilities
                </h4>
                <ul className="space-y-3 mb-8">
                  {jobData?.details?.responsibilities.map((res, i) => (
                    <li
                      key={i}
                      className="flex items-start gap-3 text-slate-600 leading-relaxed"
                    >
                      <CheckCircle2 className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
                      <span>{res}</span>
                    </li>
                  ))}
                </ul> */}

                {jobData?.details?.job_required_skills && (
                  <>
                    <h4 className="text-lg font-bold text-slate-900 mb-4">
                      Requirements & Skills
                    </h4>
                    <div>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: jobData?.details?.job_required_skills,
                        }}
                      />
                      {/* <ul className="space-y-3">
                        {jobData?.details?.job_required_skills.map((req, i) => (
                          <li
                            key={i}
                            className="flex items-start gap-3 text-slate-700 font-medium"
                          >
                            <div className="w-1.5 h-1.5 rounded-full bg-slate-400 mt-2 flex-shrink-0"></div>
                            <span>{req}</span>
                          </li>
                        ))}
                      </ul> */}
                    </div>
                  </>
                )}
              </div>
            </div>

            {/* RIGHT COLUMN (Sidebar - 4 Cols) */}
            <div className="col-span-4 xl:col-span-1 space-y-6">
              {/* Stats Card */}
              <div className="bg-slate-900 text-white rounded-[2rem] p-6 shadow-xl relative overflow-hidden">
                <div className="absolute top-0 right-0 w-32 h-32 bg-blue-500 rounded-full blur-[50px] opacity-30 -mr-10 -mt-10"></div>

                <h3 className="text-lg font-bold mb-6 flex items-center gap-2">
                  <Zap className="w-5 h-5 text-yellow-400" /> Job Insights
                </h3>

                <div className="grid grid-cols-2 gap-4">
                  <div className="bg-white/10 rounded-2xl p-4 backdrop-blur-sm border border-white/5">
                    <div className="text-slate-400 text-xs font-bold uppercase tracking-wider mb-1">
                      Impressions
                    </div>
                    <div className="text-2xl font-black">
                      {jobData.view_count}
                      {/* {jobData?.details?.view_count.toLocaleString()} */}
                    </div>
                    {/* <div className="text-green-400 text-[10px] font-bold flex items-center gap-1 mt-1">
                      <Users className="w-3 h-3" /> +12% this week
                    </div> */}
                  </div>
                  <div className="bg-white/10 rounded-2xl p-4 backdrop-blur-sm border border-white/5">
                    <div className="text-slate-400 text-xs font-bold uppercase tracking-wider mb-1">
                      Applications
                    </div>
                    <div className="text-2xl font-black">
                      {jobData.total_job_applicants}
                    </div>
                    {/* <div className="text-blue-300 text-[10px] font-bold flex items-center gap-1 mt-1">
                      <Eye className="w-3 h-3" /> High Competition
                    </div> */}
                  </div>
                </div>
              </div>

              {/* Job Overview Card */}
              <div className="bg-white rounded-[2rem] p-6 border border-slate-100 shadow-[0_4px_20px_rgba(0,0,0,0.02)]">
                <h3 className="text-lg font-bold text-slate-900 mb-6">
                  Job Overview
                </h3>

                <div className="space-y-6">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-xl bg-indigo-50 text-indigo-600 flex items-center justify-center flex-shrink-0">
                      <Building2 className="w-5 h-5" />
                    </div>
                    <div>
                      <div className="text-xs font-bold text-slate-400 uppercase tracking-wider">
                        Company Name
                      </div>
                      <div className="text-slate-900 font-bold">
                        {jobData.details.company_name}
                      </div>
                    </div>
                  </div>
                  {jobData.details.salary && (
                    <div className="flex items-start gap-4">
                      <div className="w-10 h-10 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center flex-shrink-0">
                        <IndianRupee className="w-5 h-5" />
                      </div>
                      <div>
                        <div className="text-xs font-bold text-slate-400 uppercase tracking-wider">
                          Salary
                        </div>
                        <div className="text-slate-900 font-bold">
                          {jobData.details.salary/100000} LPA
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-xl bg-purple-50 text-purple-600 flex items-center justify-center flex-shrink-0">
                      <Briefcase className="w-5 h-5" />
                    </div>
                    <div>
                      <div className="text-xs font-bold text-slate-400 uppercase tracking-wider">
                        Job Type
                      </div>
                      <div className="text-slate-900 font-bold">
                        {jobData.details.job_type}
                      </div>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-xl bg-amber-50 text-amber-600 flex items-center justify-center flex-shrink-0">
                      <Calendar className="w-5 h-5" />
                    </div>
                    <div>
                      <div className="text-xs font-bold text-slate-400 uppercase tracking-wider">
                        Apply Before
                      </div>
                      <div className="text-slate-900 font-bold">
                        {jobData.details.application_end_date}
                      </div>
                    </div>
                  </div>

                  {/* {jobData.details.experience && ( */}
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center flex-shrink-0">
                      <GraduationCap className="w-5 h-5" />
                    </div>
                    <div>
                      <div className="text-xs font-bold text-slate-400 uppercase tracking-wider">
                        Experience
                      </div>
                      <div className="text-slate-900 font-bold">
                        {jobData.details.experience
                          ? jobData.details.experience
                          : "Fresher"}
                      </div>
                    </div>
                  </div>
                  {/* ) }*/}
                </div>
              </div>

              {/* Company Brief */}
              {/* <div className="bg-white rounded-[2rem] p-6 border border-slate-100 shadow-[0_4px_20px_rgba(0,0,0,0.02)]">
                <div className="flex items-center gap-3 mb-4">
                  <img
                    src={jobData?.details?.logo}
                    alt={jobData.details.company_name}
                    className="w-10 h-10 rounded-lg object-contain border border-slate-100 p-1"
                  />
                  <div>
                    <h3 className="font-bold text-slate-900 text-sm">
                      {jobData.details.company_name}
                    </h3>
                    <a
                      href="#"
                      className="text-xs font-bold text-blue-600 hover:underline flex items-center gap-1"
                    >
                      Visit Website <Globe className="w-3 h-3" />
                    </a>
                  </div>
                </div>
                <div className="text-xs text-slate-500 font-medium leading-relaxed mb-4">
                 {jobData.details.company_description || null}
                </div>
                <button className="w-full py-2.5 rounded-xl border border-slate-200 text-slate-700 font-bold text-xs hover:bg-slate-50 transition-colors">
                  View Company Profile
                </button>
              </div> */}
            </div>
          </div>
        </div>
      </div>

      {/* Email Provider Selection Modal */}
      {isEmailModalOpen && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm">
          <div className="bg-white rounded-[2.5rem] w-full max-w-md p-8 shadow-2xl animate-in fade-in zoom-in duration-300">
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-2xl font-black text-slate-900">Send Resume</h3>
              <button
                onClick={() => setIsEmailModalOpen(false)}
                className="p-2 hover:bg-slate-100 rounded-full transition-colors"
              >
                <X className="w-6 h-6 text-slate-400" />
              </button>
            </div>

            <p className="text-slate-500 mb-8 font-medium">
              Choose your preferred way to send the resume. The email subject and body are already prepared for you.
            </p>

            <div className="space-y-3">
              <button
                onClick={() => {
                  const url = `mailto:${emailData.email}?subject=${encodeURIComponent(emailData.subject)}&body=${encodeURIComponent(emailData.body)}`;
                  window.location.href = url;
                  setIsEmailModalOpen(false);
                }}
                className="w-full flex items-center gap-4 p-4 bg-slate-50 hover:bg-blue-50 border border-slate-100 hover:border-blue-200 rounded-2xl transition-all group"
              >
                <div className="w-12 h-12 bg-white rounded-xl shadow-sm flex items-center justify-center text-blue-600 group-hover:scale-110 transition-transform">
                  <Send className="w-6 h-6" />
                </div>
                <div className="text-left">
                  <div className="font-bold text-slate-900">Default Mail App</div>
                  <div className="text-xs text-slate-500">Outlook, Apple Mail, etc.</div>
                </div>
              </button>

              <button
                onClick={() => {
                  const url = `https://mail.google.com/mail/?view=cm&fs=1&to=${emailData.email}&su=${encodeURIComponent(emailData.subject)}&body=${encodeURIComponent(emailData.body)}`;
                  window.open(url, "_blank");
                  setIsEmailModalOpen(false);
                }}
                className="w-full flex items-center gap-4 p-4 bg-slate-50 hover:bg-rose-50 border border-slate-100 hover:border-rose-200 rounded-2xl transition-all group"
              >
                <div className="w-12 h-12 bg-white rounded-xl shadow-sm flex items-center justify-center text-rose-500 group-hover:scale-110 transition-transform">
                  <MailIcon className="w-6 h-6" />
                </div>
                <div className="text-left">
                  <div className="font-bold text-slate-900">Gmail</div>
                  <div className="text-xs text-slate-500">Open in a new tab</div>
                </div>
              </button>

              <button
                onClick={() => {
                  const url = `https://outlook.office.com/mail/deeplink/compose?to=${emailData.email}&subject=${encodeURIComponent(emailData.subject)}&body=${encodeURIComponent(emailData.body)}`;
                  window.open(url, "_blank");
                  setIsEmailModalOpen(false);
                }}
                className="w-full flex items-center gap-4 p-4 bg-slate-50 hover:bg-indigo-50 border border-slate-100 hover:border-indigo-200 rounded-2xl transition-all group"
              >
                <div className="w-12 h-12 bg-white rounded-xl shadow-sm flex items-center justify-center text-indigo-600 group-hover:scale-110 transition-transform">
                  <Building2 className="w-6 h-6" />
                </div>
                <div className="text-left">
                  <div className="font-bold text-slate-900">Outlook Web</div>
                  <div className="text-xs text-slate-500">Open in a new tab</div>
                </div>
              </button>

              <button
                onClick={() => {
                  navigator.clipboard.writeText(emailData.email);
                  setSnackbarMsg("Email address copied to clipboard!");
                  setSnackbarSeverity("success");
                  setOpenSnackbar(true);
                  setIsEmailModalOpen(false);
                }}
                className="w-full flex items-center gap-4 p-4 bg-white border-2 border-dashed border-slate-200 hover:border-blue-400 rounded-2xl transition-all"
              >
                <div className="w-12 h-12 bg-slate-50 rounded-xl flex items-center justify-center text-slate-600">
                  <Share2 className="w-6 h-6" />
                </div>
                <div className="text-left">
                  <div className="font-bold text-slate-900">Copy Email Address</div>
                  <div className="text-xs text-slate-500">{emailData.email}</div>
                </div>
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Login Modal */}
      {isLoginOpen && (
        <LoginPage
          onBack={() => setIsLoginOpen(false)}
          onSignupClick={() => {
            setIsLoginOpen(false);
            setIsSignupOpen(true);
          }}
        />
      )}

      {/* Signup Modal */}
      {isSignupOpen && (
        <SignupPage
          onBack={() => setIsSignupOpen(false)}
          onLogin={() => {
            setIsSignupOpen(false);
            setIsLoginOpen(true);
          }}
        />
      )}

      <Snackbar
        open={openSnackbar}
        autoHideDuration={5000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={snackbarSeverity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbarMsg}
        </Alert>
      </Snackbar>
    </>
  );
};

export default JobDescription;
